(function () {
  var galleryTextSlide = () => {
    $(".gallery-with-text__card").hover(function () {
      var $this = $(this);
      $this.addClass("active");
      $this.siblings(".gallery-with-text__card").removeClass("active");
      setTimeout(function () {
        $this
          .children(".gallery-with-text__info")
          .children(".link--overlay")
          .addClass("active");
        $this
          .siblings(".gallery-with-text__card")
          .children(".gallery-with-text__info")
          .children(".link--overlay")
          .removeClass("active");
      }, 100);
    });
  };

  var numbersSlide = () => {
    var $slickElement = $('.gallery-with-text__wrapper.mobile').not('.slick-initialized');

    $slickElement.slick({
      slidesToShow: 3,
      arrows: false,
      dots: true,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 1330,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    });

  }

  document.addEventListener('shopify:section:load', function () {
    galleryTextSlide();
    numbersSlide();
  });

  galleryTextSlide();
  numbersSlide();
})();
